import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch, Redirect } from 'react-router-dom'

import AuctionsListContainer from './AuctionsList/AuctionsListContainer'
import LotsListContainer from './LotsList/LotsListContainer'
import LotDetailsContainer from './LotDetails/LotDetailsContainer'
import { onEnter } from '../../utils/UpdateData'

class Results extends PureComponent {
  render () {
    return (
      <div className='app-route'>
        <div className='body-container'>
          <div className='inner-container'>
            {onEnter(
              <Switch>
                <Route path='/main/results/:kindTitle/:auctionNumber/:lotNumericId'
                  component={LotDetailsContainer} />
                <Route path='/main/results/:kindTitle/:auctionNumber'
                  component={LotsListContainer} />
                <Route exact path='/main/results'
                  component={AuctionsListContainer} />
                <Redirect to='/main/results' />
              </Switch>
            )}
          </div>
        </div>
      </div>
    )
  }
}

Results.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
}
Results.defaultProps = {
}

export default Results
